<div class="user-profile--container mat-typography">
  <div class="app-header--container">
    <span class="hidden-print">
      <summit-header
        [imagesURL]="environment.imagesURL"
        [alertsURL]="environment.alertsServices"
        [isProduction]="environment.isNotLocalhost"
        [isStrippedDownHeader]="isStrippedDownHeader">
      </summit-header>
    </span>
  </div>

  @if(isStrippedDownHeader) {
    <div class="app-header--unsecure-app">
      <span class="app-header--title-text"><i>Know</i> the People Who Know Workers' Comp.<span class="trademark">&reg;</span></span>
    </div>
  } @else {
    <div class="app-header--secure-app">
      <span class="app-header--title-text">{{appTitle}}</span>
    </div>
  }

  <div id="app-content-container" [ngClass]="{'app-content--swirl-background': isStrippedDownHeader}">
    <div class="summit-container">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="app-footer--container">
    <span class="hidden-print">
      <summit-footer
        [imagesURL]="environment.imagesURL"
        [isProduction]="environment.isNotLocalhost"
        [appProgrammaticName]="environment.appProgrammaticName">
      </summit-footer>
    </span>
  </div>
</div>
